module.exports = __webpack_public_path__ + "img/time.0f77ea57.png";